import { useLocation, useNavigate } from 'react-router-dom';
import '../../styles/userEntry.scss'
import { useEffect, useState } from 'react'
import { useNotification } from '../../context/NotificationContext';
import { resendCode, verifyCode } from '../../api/requests';
import LoaderBtn from '../LoaderBtn/LoaderBtn';
import 'animate.css'
import { NavLink } from 'react-router-dom';

const VerifyOtpCustomer = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const { notify } = useNotification()

    const [otpData, setOtpData] = useState({
        code: '',
        user_email: '',
        isLoading: false,
        isResendLoading: false,
        afterVerificationUrl: ''
    })

    const state = location.state as { email: string, afterVerificationUrl: string };

    useEffect(() => {
        if (!state) {
            navigate('/signin'); // Go back to previous page
        }
    }, [state, navigate]);


    useEffect(() => {

        setOtpData((prev) => {

            return {
                ...prev,
                user_email: state.email,
                afterVerificationUrl: state.afterVerificationUrl
            }

        })
        // eslint-disable-next-line
    }, [])

    if (!state) return null;

    const handleInput = (key: string, value: string | boolean) => {

        setOtpData((prev) => {
            return {
                ...prev,
                [key]: typeof value === 'string' ? value.trim() : value
            }
        })

    }

    const setLoader = (val: boolean) => {

        setOtpData((prev) => {
            return {
                ...prev,
                isLoading: val
            }
        })

    }


    const setResendLoader = (val: boolean) => {

        setOtpData((prev) => {
            return {
                ...prev,
                isResendLoading: val
            }
        })

    }



    const handleVerify = async () => {

        if (otpData.code === '') {
            notify.error('Enter OTP code to continue')
            return
        }


        try {
            setLoader(true)

            let req = {
                code: otpData.code,
                email: otpData.user_email
            }

            let process = await verifyCode(req)


            if (process) {
                notify.success('E-mail verified successfully,sign-in to your account to continue')
                navigate(otpData.afterVerificationUrl, { replace: true })
            }


        } catch (error: any) {
            notify.error(error.message)
        } finally {
            setLoader(false)
        }


    }

    const handleResend = async () => {

        try {
            setResendLoader(true)

            let result = await resendCode(otpData.user_email)


            if (result) {
                notify.success('New code has been sent to your registered e-mail')
            }


        } catch (error: any) {
            notify.error(error.message)
        } finally {
            setResendLoader(false)
        }


    }


    return (<div className="sectionarea" >

        <div className='content animate__animated animate__fadeIn animate__fast'>
            
            <NavLink to={'/'}>
                <div className='logoArea'>
                    <div className='icon logo_initials'></div>
                    <div className='icon logo_name'></div>
                </div>
            </NavLink>

            <div className='intro'>
                <div className='title'>Email Verification</div>
                <div className='text'>Enter the code sent to your e-mail for the verification of your account</div>
            </div>


            <div className='inputArea'>

                <div className='inputPack'>
                    <label className='inputTitle'>Code</label>
                    <input className='inputBox' type='text' value={otpData.code} onChange={(ev) => handleInput('code', ev.currentTarget.value)}></input>
                </div>

            </div>

            <div className='btn_grid'>


                <LoaderBtn className={'btn'} text={'Verify'} thickness={3} clickFunction={handleVerify} isLoading={otpData.isLoading}></LoaderBtn>

                <LoaderBtn className={'btn google'} text={'Resend code'} thickness={3} clickFunction={handleResend} isLoading={otpData.isResendLoading}></LoaderBtn>

                {/* <div className='btn' onClick={handleVerify}>
                    Verify
                </div> */}



                {/* <div className='btn google' onClick={handleVerify}>
                    Resend code
                </div> */}

            </div>



        </div>

    </div>)
}

export default VerifyOtpCustomer;